export default "__VITE_ASSET__BPffN$qG__"